(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-nunu-localization][open]').forEach((picker) => {
      if (picker !== except) picker.open = false;
    });
  };
  const positionPanel = (picker) => {
    const trigger = picker.querySelector('summary');
    const panel = picker.querySelector('.nunu-localization__panel');
    const anchor = trigger.getBoundingClientRect();
    const size = panel.getBoundingClientRect();
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight;
    const left = Math.max(12, Math.min(anchor.right - size.width, width - size.width - 12));
    let top = anchor.bottom + 8;
    if (top + size.height > height - 12) top = anchor.top - size.height - 8;
    top = Math.max(12, Math.min(top, height - size.height - 12));
    panel.style.setProperty('--nunu-panel-left', `${left}px`);
    panel.style.setProperty('--nunu-panel-top', `${top}px`);
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-nunu-localization]').forEach((picker) => {
      if (picker.dataset.ready) return;
      picker.dataset.ready = 'true';
      const panel = picker.querySelector('.nunu-localization__panel');
      if (typeof panel.showPopover === 'function') panel.setAttribute('popover', 'manual');
      picker.querySelectorAll('.nunu-localization__submit').forEach((button) => {
        button.hidden = true;
      });
      picker.addEventListener('toggle', () => {
        if (!picker.open) {
          if (panel.matches(':popover-open')) panel.hidePopover();
          return;
        }
        closeAll(picker);
        if (panel.hasAttribute('popover') && !panel.matches(':popover-open')) panel.showPopover();
        positionPanel(picker);
      });
      picker.querySelectorAll('[data-nunu-locale-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.form;
          if (!form) return;
          const returnTo = form.querySelector('[name="return_to"]');
          if (returnTo) returnTo.value = window.location.pathname + window.location.search;
          form.requestSubmit();
        });
      });
    });
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-nunu-localization][open]').forEach((picker) => {
      if (!picker.contains(event.target)) picker.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = document.querySelector('[data-nunu-localization][open]');
    if (!picker) return;
    event.preventDefault();
    event.stopPropagation();
    picker.open = false;
    picker.querySelector('summary').focus();
  });
  window.addEventListener('resize', () => closeAll());
  window.addEventListener('scroll', () => closeAll(), { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
